
import axios from 'axios';

export default function () {
    window.onerror = function (err, script, line) {
        try {
            axios.post(global.getEndPoint() + 'api/frontend-log', {
                message: err + ' [Script: ' + script + '] [Line: ' + line + ']',
                location: window.location.href
            });
        } catch (tmp) {}
    };
};


//////////////////
// WEBPACK FOOTER
// ./plugins/global-error-handler.js
// module id = ./plugins/global-error-handler.js
// module chunks = 54